export interface IAuthRepository {
  setAuth: (authToken: string) => void
  getAuth: () => string
}

export const authRepository: IAuthRepository = {
  setAuth(authToken: string) {
    window.sessionStorage.setItem('authToken', authToken)
  },

  getAuth(): string {
    return window.sessionStorage.getItem('authToken') as string
  },
}
